// ══════════════════════════════════════════════════════
//  extractors/newsSignals.js — 新闻语义信号
//
//  源：raw.surfNews（采集原文标题/source/时间）
//      a.news_signals（AI 提取的红绿旗 + sentiment）
// ══════════════════════════════════════════════════════

import { safeNum } from './_shared';

export function isAvailable(project, a) {
  const ns = a?.news_signals;
  const hasSignals = !!ns && (
    (ns.red_flags?.length || 0) > 0 ||
    (ns.green_flags?.length || 0) > 0 ||
    ns.sentiment != null
  );
  // 与 extract() 对齐：raw news feed 也算可用（即便 AI 还没提取出 signals）
  const hasRawNews = !!(project?.surfNews?.trending?.length || project?.surfNews?.recent?.length);
  return hasSignals || hasRawNews;
}

export function extract(project, a) {
  const ns = a?.news_signals;
  const surfNews = project?.surfNews;
  if (!ns && !surfNews) return null;

  return {
    sentiment: safeNum(ns?.sentiment),
    redFlags:    (ns?.red_flags    || []).filter(Boolean),
    greenFlags:  (ns?.green_flags  || []).filter(Boolean),
    redFlagsEn:  (ns?.red_flags_en   || []).filter(Boolean),
    greenFlagsEn:(ns?.green_flags_en || []).filter(Boolean),
    summaryZh:   ns?.summary || '',
    summaryEn:   ns?.summary_en || '',
    rawTrending: surfNews?.trending || [],
    rawRecent:   surfNews?.recent   || [],
  };
}
